export default __webpack_public_path__ + "static/scggfx_hover-1d67d4af2dcb63ea421e173307f43fb1.png";